export default __webpack_public_path__ + "static/graph-513ca84d4c4e117bcd19cd62f6f0496f.svg";